/**
 * Created by Administrador on 10/3/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('Account', AccountService);

    AccountService.$inject = ['$resource', 'CONFIG'];

    function AccountService($resource, CONFIG) {
        var urlBaseOauth = CONFIG.API_URL + '/uaa';

        return $resource(urlBaseOauth + '/account', {
            get: {
                method: 'GET'
            }
        });
    }
})();
